import { FlowTypes } from '@folx-types/flow';

import flowThemes from './FlowThemes';

export const getThemeForFlow = (flow: FlowTypes) =>
	flow in flowThemes ? flowThemes[flow as keyof typeof flowThemes] : flowThemes.default;
